export default "__VITE_ASSET__DTf6VkTt__"